import { createSelector } from 'reselect';
import { flow, sortBy, map, values, flatten, get } from 'lodash/fp';

import { IN_PROGRESS } from '../constants/challengeStatusTypes';
import { makeInitials } from '../utils/playerUtils';

function getMatchUps(allPlayers, tiers, ruledOutPlayers) {
  return map(tier => {
    const ruledOut = tier.find(pId => ruledOutPlayers.includes(pId));
    return map(pId => {
      const player = allPlayers[pId];
      return {
        ...player,
        ruledOut,
        initials: makeInitials(player.name)
      };
    })(tier);
  })(tiers);
}

function filterMatchUps(matchUps, playersSubmitted) {
  const entrySelections = flow(
    values,
    flatten,
    map('id')
  )(playersSubmitted);
  return map(tier => sortBy(player => !entrySelections.includes(player.id), tier))(matchUps);
}

function getSortedMatchUps(statusId, allPlayers, playersSubmitted, tiers, ruledOutPlayers) {
  const matchUps = getMatchUps(allPlayers, tiers, ruledOutPlayers);
  if (statusId < IN_PROGRESS) {
    return matchUps;
  }
  return filterMatchUps(matchUps, playersSubmitted);
}

const matchUpsSelector = createSelector(
  get('challenge.statusId'),
  get('challenge.players'),
  get('entry.myEntry.playersSubmitted'),
  get('challenge.rapidfireTiers'),
  get('challenge.rapidfireRuledOutPlayers'),
  getSortedMatchUps
);

export default matchUpsSelector;
